export default __webpack_public_path__ + "static/media/logo_dark_background.83ce5026.png";